import $ from 'jquery';
import Croppie from 'croppie';

export class ImageCropper {

    croppie;
    options;

    cropView;
    fileInput;
    resultView;
    saveButton;
    dataInput;
    placeholder;

    base64Image;

    constructor(cropView, fileInput, saveButton, resultView, dataInput, placeholder, options) {
        this.cropView = $(cropView);
        this.fileInput = fileInput;
        this.resultView = resultView;
        this.saveButton = saveButton;
        this.dataInput = dataInput;
        this.placeholder = placeholder;

        options.showZoomer = true;
        options.enableExif = true;
        this.options = options;
        if (!this.options.hasOwnProperty('resultSize')) {
            this.options.resultSize = 'viewport';
        }
        if (!this.options.viewport.hasOwnProperty('type')) {
            this.options.viewport.type = 'square';
        }

        this.croppie = new Croppie(this.cropView[0], options);

        this.fileInput.change(() => {
            this.readFile()
        });
        saveButton.click(e => {
            this.save(e)
        });

        this.setState('start');
    }

    readFile() {
        if (this.fileInput.prop('files') && this.fileInput.prop('files')[0]) {
            let reader = new FileReader();

            reader.onload = (e) => {
                this.croppie.bind({
                    url: e.target.result
                });

                this.setState('crop');
            }

            reader.readAsDataURL(this.fileInput.prop('files')[0]);
        }
    }

    save(e) {
        e.preventDefault();

        this.croppie.result({
            type: 'canvas',
            size: this.options.resultSize
        }).then(resp => {
            this.base64Image = resp;
            this.resultView.attr('src', resp);
            this.dataInput.attr('value', resp);
            this.fileInput.val('');

            this.setState('preview');

            if (this.dataInput.hasClass('croppie-save-ajax')) {
                this.saveUsingAjax();
            }
        });
    }

    saveUsingAjax() {
        const data = {_token: $('meta[name=csrf-token]').attr('content')};
        data[this.dataInput.attr('name')] = this.base64Image;
        $.ajax({
            method: 'PATCH',
            data: data,
            dataType: "json"
        });
    }

    setState(state) {
        switch (state) {
            case 'start':
                this.fileInput.show();
                this.cropView.hide();
                this.saveButton.hide();
                break;
            case 'crop':
                this.fileInput.hide();
                this.cropView.show();
                this.resultView.hide();
                this.saveButton.show();
                break;
            case 'preview':
                this.fileInput.show();
                this.cropView.hide();
                this.resultView.show();
                this.saveButton.hide();
                if(!!this.placeholder) {
                    this.placeholder.hide();
                }
                break;
        }
    }
}
